// extracted by mini-css-extract-plugin
export default {"container":"spo_3I44H","image":"spo_ima_vui5u","label":"spo_lab_m6viZ","withImage":"spo_wit_1Pgie","link":"spo_lin_1487Z","withoutPresentedBy":"spo_wit_2M0Cq"};